import { CountryIsoCode, Employment } from "@oysterhr/schema"

export const useDisplayHourlyRateSalary = (countryCode: Employment["countryCode"]) =>
  countryCode === CountryIsoCode.Us
